// WizardForm Field
export const wizardFormType = "type"
export const wizardFormMustHave = "musthave"
export const wizardFormHasSubOption = "has_suboption"
export const wizardFormDirectYN = "direct_yn"
export const wizardFormSubList = "suboption"

// WizardFormType
export const wizardFormTypeSelect = "select"
export const wizardFormTypeDate = "datetime"
export const wizardFormTypeOption = "option"
export const wizardFormTypeRadio = "radio"

// WizardType Y/N
export const wizardFormY = "Y"
export const wizardFormN = "N"

// WizardFormDelivery
export const wizardFormQuantity = "수량 여부";
export const wizardFormDelivery = "배송 여부";
export const wizardFormDeliveryZipcode = "zipcode";
export const wizardFormDeliveryAddress1 = "address1";